/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'embedded-confluence-common.src.content.empty-state-description':
    'A gente procurou em todo lugar, mas ela não existe. Talvez tenha sido excluída. A menos, é claro, que o URL contenha um erro de digitação 😉',
  'embedded-confluence-common.src.content.empty-state-header': 'Não foi possível encontrar o que você está procurando',
  'embedded.confluence.already-logged-in-paragraph': 'Já entrou? Experimente atualizar.',
  'embedded.confluence.footer.hover.text': 'Visualizar no Confluence',
  'embedded.confluence.footer.prefix': 'Distribuído por',
  'embedded.confluence.generic-error-page.login-to-confluence-button': 'Entrar no Confluence',
  'embedded.confluence.login-page.login-button': 'Entrar no Confluence',
  'embedded.confluence.login-page.login-button.aria-label': 'Botão Entrar',
  'embedded.confluence.login-page.login-text': 'Você precisa entrar para ver esta página',
  'embedded.confluence.login-page.refresh-page-banner':
    'Depois do login, a atualização da página é automática. Se isso não acontecer, você pode clicar aqui para atualizar',
  'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Atualizar página',
  'embedded.confluence.need-to-log-in-paragraph': 'Você precisa entrar para ver esta página',
  'embedded.confluence.still-having-trouble-paragraph':
    'Ainda está tendo problemas? Verifique se os cookies de terceiros estão habilitados ou {link}',
  'embedded.confluence.troubleshooting-link-text': 'consulte este guia de solução de problemas.',
  'embedded.confluence.troubleshooting-link.aria-label': 'link do guia de solução de problemas',
};
